export default {
    toggleOverlay: (state, payload) => {
        state.overlay = payload;
    }
}